<div class="background">
  <div class="enter-mail-block">
    <div class="back-button" (click)="onClickBackBtn()"></div>
    <div class="title-auth">Вход в аккаунт DexBee</div>
    @if (IsShowCodeSend) {
    <div class="input-mail-block">
      <input class="input-mail" type="email" placeholder="Введите Email" (input)="onTextBoxChange()" (keyup.enter)="onClickSendBtn()"
        [(ngModel)]="EmailText">
    </div>
    }
    @else {
    <div class="title-code">Введите код, отправленный на указанную почту</div>
    <div class="check-code-block {{CheckCodeBlockStyle}}">
      <input class="input-code {{CheckCodeBlockStyle}}" (input)="onCodeChange()" [(ngModel)]="CodeText" mask="000-000" [showMaskTyped]="true">
      <div class="error-code">{{ErrorCodeMessage}}</div>
    </div>
    }
    @if (ErrorMessage) {
    <div class="error">{{ErrorMessage}}</div>
    }
    @if (SendButtonVisible) {
    <div class="button {{SendButtonStyle}}" (click)="onClickSendBtn()">
      {{SendBtnText}}
    </div>
    }
    @else {
    <div class="timer">{{TimerMessage}}</div>
    }
  </div>

</div>